import DOMPurify from "isomorphic-dompurify";
import * as React from "react";

interface StationDescriptionProps {
  description: string | null | undefined;
}

export function StationDescription({ description }: StationDescriptionProps) {
  if (!description) {
    return null;
  }

  // Sanitize the HTML description
  const sanitizedHtml = DOMPurify.sanitize(description);

  return (
    <div className="w-full rounded-lg border border-border bg-white p-4 shadow-md dark:bg-gray-800">
      <h2 className="mb-4 text-xl font-semibold text-card-foreground">
        Descrição
      </h2>
      <article
        className="prose w-full max-w-none break-words px-1 text-foreground prose-a:text-blue-600 prose-strong:text-foreground dark:text-gray-300 dark:prose-a:text-blue-400 dark:prose-strong:text-gray-200"
        dangerouslySetInnerHTML={{
          __html: sanitizedHtml,
        }}
      />
    </div>
  );
}
